const StepHeader = ({ stepCount, title, stepProgress }: { stepCount: string, title: string, stepProgress: number }) => {
    return (<div className='step-header' >
      <div className='step-header-step' >{stepCount}</div>
      <h3>{title}</h3>
      <div className='progress-bar-outer' >
        <div className='progress-bar-inner' style={{ width: `${stepProgress}%` }} ></div>
      </div>
    </div>
    )
  }

  export default StepHeader;